import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./auditFormView.css";

import APICaller from "../../../utils/APICaller";
import secureLocalStorage from "react-secure-storage";
import { PlusOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CustomLoader from "../../common/customLoader";

const AuditFormEdit = ({ children = null, key_elem = "1", nameLink = "" }) => {
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const [form] = Form.useForm();
  const { confirm } = Modal;
  const { Option } = Select;

  const [showLoader, setShowLoader] = useState(true);
  const [isWeightageForm, setIsWeightageForm] = useState(false);
  const [parameters, setParameters] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [errors, setErrors] = useState([]);
  const [auditFormSelectedProcess, setAuditFormSelectedProcess] = useState();
  const [activeAudits, setActiveAudits] = useState();
  const [error, setError] = useState("");

  /*begin::getAuditFormDetail will fetch audit form's detail*/
  const getAuditFormDetail = () => {
    const endpoint = `/auditForms/edit/${id}`;
    const method = "GET";
    const payload = {};

    APICaller(slsRole, slsToken, endpoint, method, payload)
      .then((response) => {
        setAuditFormSelectedProcess(response.process);
        setActiveAudits(response.activeAudits);

        setIsWeightageForm(response?.hasWeightage === "TRUE" ? true : false);

        form.setFieldsValue({
          status: response?.status,
        });

        // Set Parameters
        const parsedQMF = JSON.parse(response.formContent);
        const questions =
          parsedQMF?.elements?.questions &&
          parsedQMF?.elements?.questions.filter(
            (questions) => questions.input_type === "radio-group"
          );
        setParameters(questions);

        setShowLoader(false);
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };
  /*end::getAuditFormDetail will fetch audit form's detail*/

  const handleCheckboxChange = (e) => {
    setIsWeightageForm(e.target.checked); // Update state when checkbox is toggled
  };

  const handleAddParameter = () => {
    const qualityParametersLength = document.getElementsByClassName(
      "drgdrp-form-innerContainer"
    ).length;

    const newParameter = {
      serial_no: String(qualityParametersLength + 1),
      type: "radio-group",
      display_text: "",
      meta: { critical: false, required: false },
    };

    if (isWeightageForm) {
      newParameter.meta.weightage = null;
    }

    setParameters([...parameters, newParameter]);
    setError(""); // Clear the error when adding a parameter

    // Update form values to include the new parameter
    const weightage = isWeightageForm && {
      [`weightage_${parameters.length}`]: newParameter.meta.weightage || null,
    };
    const updatedValues = {
      ...form.getFieldsValue(),
      [`serial_no_${parameters.length}`]: String(newParameter.serial_no),
      [`type_${parameters.length}`]: newParameter.type,
      [`displayText_${parameters.length}`]: newParameter.display_text,
      ...weightage,
      [`critical_${parameters.length}`]: newParameter?.meta.critical || false,
      [`required_${parameters.length}`]: newParameter?.meta.required || false,
    };
    form.setFieldsValue(updatedValues);
  };

  const handleRemoveParameter = (index) => {
    const updatedParameters = parameters.filter((_, i) => i !== index);

    // Reindex the remaining parameters
    const reindexedParameters = updatedParameters.map((param, i) => ({
      ...param,
      serial_no: String(i + 1), // Update the serial_no based on the new index
    }));

    setParameters(reindexedParameters);
    // Update form values to reflect the removal
    const updatedValues = {};

    reindexedParameters.forEach((param, i) => {
      updatedValues[`serial_no_${i}`] = String(param.serial_no);
      updatedValues[`type_${i}`] = param.input_type;
      updatedValues[`displayText_${i}`] = param.display_text;

      // Update weightage values only if isWeightageForm is true
      if (isWeightageForm) {
        updatedValues[`weightage_${i}`] = param.meta.weightage;
      }

      updatedValues[`critical_${i}`] = param.meta.critical || false;
      updatedValues[`required_${i}`] = param.meta.required || false;
    });
    form.setFieldsValue(updatedValues);
  };

  const onFinish = (values) => {
    if (parameters.length === 0) {
      setError("Please add at least one parameter.");
      return;
    }
    // Show a confirmation modal
    confirm({
      title:
        "Please review your selected or entered information carefully before submitting the form, as changes may not be possible once it's submitted.",
      content: "Are you sure you want to submit the form?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        setError("");
        const endpoint = `/auditForms/${id}`;
        const method = "PUT";
        let selectedProcess = {};
        if (processes && processes?.length > 0) {
          selectedProcess =
            processes &&
            processes.find((process) => {
              return process.value === auditFormSelectedProcess;
            });
        }
        values["isWeightageForm"] = isWeightageForm;
        const payload = {
          slsRole,
          formName: selectedProcess && selectedProcess?.label,
          process: selectedProcess && selectedProcess?.value,
          hasWeightage: isWeightageForm === true ? "TRUE" : "FALSE",
          formContent: values,
          status: values?.status,
          historySource: "backend",
          historyAction: "update",
          historyUserID: slsLIUId,
          updatedAt: new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 19)
            .replace("T", " "),
        };

        APICaller(slsRole, slsToken, endpoint, method, payload)
          .then((response) => {
            setErrors([]);
            message.success("AuditForm updated successfully");
            form.resetFields();
            setParameters([]);
            getAuditFormDetail();
          })
          .catch((error) => {
            const errorMessage =
              error.data?.message ||
              "An error occurred while updating the auditForm";
            setErrors([errorMessage]);
            message.error(errorMessage);
          });
      },
      onCancel() {
        // User canceled
        console.log("Form submission canceled");
      },
    });
  };

  /*begin::getProcesses will fetch the list of Processes*/
  const getProcesses = async () => {
    const endpoint = "/processes/fetchWithoutPagination";
    const method = "POST";
    const payload = { role: slsRole };

    await APICaller(slsRole, slsToken, endpoint, method, payload)
      .then((response) => {
        const temp = [];
        response?.map((process, index) => {
          temp.push({ label: process?.name, value: process?._id });
        });

        setProcesses(temp);
      })
      .catch((error) => {});
  };
  /*end::getProcesses will fetch the list of Processes*/

  useEffect(() => {
    getProcesses();
    getAuditFormDetail();
  }, [location?.state?.route]);

  // useEffect(() => {
  //   if (processes && processes?.length > 0) {
  //     let selectedProcess =
  //       processes &&
  //       processes.find((process) => {
  //         return process.value === auditFormSelectedProcess;
  //       });

  //     if (selectedProcess) {
  //       form.setFieldValue("process", selectedProcess);
  //     }
  //   }
  // }, [processes, auditFormSelectedProcess]);

  ////
  // useEffect(() => {
  //   // Update form values to reflect the removal
  //   const updatedValues = {};
  //   parameters.forEach((param, i) => {
  //     updatedValues[`type_${i}`] = param.input_type;
  //     updatedValues[`displayText_${i}`] = param.display_text;
  //     updatedValues[`weightage_${i}`] = param.weightage;
  //     updatedValues[`critical_${i}`] = param.critical || false;
  //     updatedValues[`required_${i}`] = param.required || false;
  //   });
  //   form.setFieldsValue(updatedValues);
  // }, [auditFormSelectedProcess]);

  //form.setFieldsValue(updatedValues);
  // Initial parameter values
  const initialParameters = [
    {
      id: "1",
      type: "radio-group",
      name: "Parameter 1",
      display_text: "Parameter 1",
      displayText: "Parameter 1",
      meta: { weightage: 10, critical: false, required: false },
    },
    {
      id: "2",
      type: "radio-group",
      name: "Parameter 2",
      display_text: "Parameter 2",
      displayText: "Parameter 2",
      meta: { weightage: 20, critical: false, required: true },
    },
    {
      id: "3",
      type: "radio-group",
      name: "Parameter 3",
      display_text: "Parameter 3",
      displayText: "Parameter 3",
      meta: { weightage: 30, critical: false, required: true },
    },
    {
      id: "4",
      type: "radio-group",
      name: "Parameter 4",
      display_text: "Parameter 4",
      displayText: "Parameter 44",
      meta: { weightage: 40, critical: true, required: true },
    },
  ];

  // Function to handle drag end event and reorder parameters
  const onDragEnd = (result) => {
    const { source, destination } = result;

    // Exit if dropped outside the list
    if (!destination) return;

    // Reorder the parameters array based on drag result
    const reorderedParameters = Array.from(parameters);
    const [removed] = reorderedParameters.splice(source.index, 1);
    reorderedParameters.splice(destination.index, 0, removed);

    // Update the state with the new order
    setParameters(reorderedParameters);

    // Update form values with the new parameter order
    updateFormValues(reorderedParameters);
  };

  // Function to update form values after parameters are reordered
  const updateFormValues = (params) => {
    const updatedValues = {};
    params.forEach((param, index) => {
      updatedValues[`type_${index}`] =
        param.input_type || param.type || "radio-group";
      updatedValues[`displayText_${index}`] = param.display_text;

      // Update weightage values only if isWeightageForm is true
      if (isWeightageForm) {
        updatedValues[`weightage_${index}`] = param.meta.weightage;
      }

      updatedValues[`critical_${index}`] = param.meta.critical || false;
      updatedValues[`required_${index}`] = param.meta.required || false;
    });
    form.setFieldsValue(updatedValues); // Sync form values with the new order
  };

  // Effect hook to set initial form values when the component mounts
  useEffect(() => {
    updateFormValues(parameters);
  }, [parameters]);

  return (
    <div className="all-content roleCont commonTCont">
      <CustomLoader showLoader={showLoader} />

      <div className="all-table-holder">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="parameters">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="drgdrp-outerContainer"
              >
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className="drgdrp-form-outerContainer"
                >
                  <Form.Item
                    name="isWeightageForm"
                    initialValue={isWeightageForm}
                  >
                    <Checkbox
                      checked={isWeightageForm}
                      onChange={handleCheckboxChange}
                      className="weightTage"
                    >
                      Is this a Weightage Form?
                    </Checkbox>
                  </Form.Item>
                  <div className="d-flex justify-content-between">
                    <h3 className="qualityParameters">Quality Parameters</h3>
                    <Button
                      type="dashed"
                      onClick={handleAddParameter}
                      icon={<PlusOutlined />}
                      className="ant-btn ant-btn-primary addParameter-btn"
                    >
                      Add Parameter
                    </Button>
                  </div>
                  {parameters.map((param, index) => (
                    <Draggable
                      key={String(param.serial_no)}
                      draggableId={String(param.serial_no)}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="drgdrp-form-innerContainer"
                          style={{
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Form.Item
                            name={`type_${index}`}
                            initialValue={param.type}
                            hidden
                          >
                            <span></span>
                          </Form.Item>

                          {/* Title */}
                          <Form.Item
                            name={`displayText_${index}`} // This ensures that form field names are dynamically set
                            label=""
                            rules={[
                              {
                                required: true,
                                message: "Title is required",
                              },
                            ]}
                          >
                            <textarea
                              className={`text__area`}
                              value={param.displayText}
                              placeholder="Enter a title"
                              onChange={(e) => {
                                // Update parameter value when input changes
                                const newParameters = parameters.map((p) => {
                                  return p.serial_no === param.serial_no
                                    ? { ...p, display_text: e.target.value }
                                    : p;
                                });

                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                              rows={2}
                              width={"full"}
                            ></textarea>
                          </Form.Item>

                          {/* Critical */}
                          <Form.Item
                            name={`critical_${index}`}
                            initialValue={false}
                            label=""
                          >
                            <Checkbox
                              checked={param?.meta?.critical}
                              onChange={(e) => {
                                const isChecked = e.target.checked; // Get true/false based on checkbox state

                                // Update critical when input changes
                                const newParameters = parameters.map((p) =>
                                  p.serial_no === param.serial_no
                                    ? {
                                        ...p,
                                        meta: {
                                          ...p.meta,
                                          critical: isChecked,
                                        },
                                      }
                                    : p
                                );
                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                            >
                              Critical
                            </Checkbox>
                          </Form.Item>

                          {/* Mandatory */}
                          <Form.Item name={`required_${index}`} label="">
                            <Checkbox
                              checked={param?.meta?.required}
                              onChange={(e) => {
                                const isChecked = e.target.checked; // Get true/false based on checkbox state

                                // Update required when input changes
                                const newParameters = parameters.map((p) =>
                                  p.serial_no === param.serial_no
                                    ? {
                                        ...p,
                                        meta: {
                                          ...p.meta,
                                          required: isChecked,
                                        },
                                      }
                                    : p
                                );
                                setParameters(newParameters);
                                updateFormValues(newParameters); // Synchronize form values
                              }}
                            >
                              Mandatory
                            </Checkbox>
                          </Form.Item>

                          {isWeightageForm && (
                            <Form.Item
                              name={`weightage_${index}`}
                              label=""
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter weightage",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter weightage"
                                type="number"
                                value={param.meta.weightage}
                                onChange={(e) => {
                                  // Update weightage when input changes
                                  const newParameters = parameters.map((p) =>
                                    p.serial_no === param.serial_no
                                      ? {
                                          ...p,
                                          meta: {
                                            ...p.meta,
                                            weightage: parseInt(e.target.value),
                                          },
                                        }
                                      : p
                                  );
                                  setParameters(newParameters);
                                  updateFormValues(newParameters); // Synchronize form values
                                }}
                              />
                            </Form.Item>
                          )}
                          <Button
                            danger
                            onClick={() => handleRemoveParameter(index)}
                          >
                            Remove
                          </Button>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  <Form.Item label="Status" name="status" className="status">
                    <Select>
                      <Option value="ACTIVE">ACTIVE</Option>
                      <Option value="INACTIVE">IN-ACTIVE</Option>
                    </Select>
                  </Form.Item>

                  <Button
                    type="primary"
                    htmlType="submit"
                    className="ant-btn ant-btn-primary submit-btn border-0 rounded"
                  >
                    Update
                  </Button>
                </Form>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};
export default AuditFormEdit;
